// El `[registro:]` con el que el historial del chat recuerda lo que el usuario contestó
// en un cuestionario `preguntar` (la card `PreguntasCard`, tool global de
// `V2_AGENT_TOOLS`). Las respuestas viven en el `tool_result`, que no se re-manda en los
// turnos siguientes: sin esto el agente las olvidaba al turno siguiente
// (ADR-2026-09-12-preguntar-es-global-y-el-chat-no-la-duplica).
//
// Contrato de la card: `{ respuestas: [{ id, pregunta, elegidas: string[] }] }`.

const MAX_LARGO_LINEA = 220;

export function registroPreguntasParaHistorial(response: unknown): string | null {
  const r = response as
    | { respuestas?: Array<{ id?: unknown; pregunta?: unknown; elegidas?: unknown }> }
    | null
    | undefined;
  const lista = Array.isArray(r?.respuestas) ? r.respuestas : [];
  const lineas = lista
    .filter(
      (x) =>
        !!x &&
        typeof x.pregunta === 'string' &&
        Array.isArray(x.elegidas) &&
        x.elegidas.some((e) => typeof e === 'string' && e.trim()),
    )
    .map((x) => {
      const pregunta = String(x.pregunta).replace(/[?¿]/g, '').trim();
      const elegidas = (x.elegidas as unknown[]).filter((e): e is string => typeof e === 'string' && !!e.trim());
      return `${pregunta}: ${elegidas.join(', ')}`.slice(0, MAX_LARGO_LINEA);
    });
  if (lineas.length === 0) return null;
  return `[registro: preguntaste con opciones y el usuario respondió — ${lineas.join(' · ')}]`;
}
